export const clearedFilters = {
    sortBy: 'productiondate',
    sortOrder: 'ASC',
    sortEmpty: 'ALL',
    productNr: '',
    orderNr: '',
    customer: '',
    reference: '',
    ralNr: '',
    ralType: '',
    powderNr: '',
    productionDate: '',
    deliveryDate: '',
    overviewInfo: '',
    materialType: null,
    productType: 0,
    count: 0,
    flow: null,
    workingDaysUntilProduction: 10,
};
